module.exports = __webpack_public_path__ + "img/final.15d000cd.gif";